module.exports = "/fonts/fa-regular-400.woff?f45b750ae42cc175e2273a6eee86c2b5";